/* eslint-disable react/jsx-props-no-spreading, indent */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Checkbox from '../buttons/Checkbox';
import FullButton from '../buttons/Full';

import styles from '../../../styles/partials/cookies.scss';
import useConsent from '../../hooks/useConsent';

const messages = defineMessages({
    cookies: {
        id: 'content.cookies.title',
        defaultMessage: 'Vos paramètres de confidentialité',
    },
    more: {
        id: 'content.cookies.more',
        defaultMessage: 'Pour en savoir plus veuillez lire ',
    },
    more_link: {
        id: 'content.cookies.more_link',
        defaultMessage: 'notre politique de confidentialité',
    },
    cookies_confirm: {
        id: 'content.cookies.confirm',
        defaultMessage: 'Enregistrer mes paramètres',
    },
    cookies_accept: {
        id: 'content.cookies.accept',
        defaultMessage: 'Tout accepter',
    },
    cookies_reject: {
        id: 'content.cookies.deny',
        defaultMessage: 'Tout rejeter',
    },
});

const propTypes = {
    onClose: PropTypes.func,
    onPrivacyPage: PropTypes.func,
};

const defaultProps = {
    onClose: null,
    onPrivacyPage: null,
};

const CookiesForm = ({ onClose, onPrivacyPage }) => {
    const { choices, onClickChoice, onClickConfirm, onClickAccept, onClickDeny } = useConsent({
        onClose,
    });

    const onClickTerms = useCallback(() => {
        if (onPrivacyPage !== null) {
            onPrivacyPage();
        }
    }, []);

    return (
        <div className={styles.container}>
            {choices.map(
                ({
                    id = null,
                    label = null,
                    value = false,
                    description = null,
                    disabled = false,
                }) => (
                    <div className={styles.choice} key={`cookie-${id}`}>
                        <div className={styles.checkbox}>
                            <Checkbox
                                value={value}
                                disabled={disabled}
                                label={label}
                                onClick={() => onClickChoice(id, !value)}
                            />
                        </div>
                        <p className={styles.description}>{description}</p>
                    </div>
                ),
            )}
            <div className={styles.more}>
                <p className={styles.description}>
                    <FormattedMessage {...messages.more} />{' '}
                    <Link to="/politique-de-confidentialite" onClick={onClickTerms}>
                        <FormattedMessage {...messages.more_link} />
                    </Link>
                    .
                </p>
            </div>
            <div className={styles.buttons}>
                <FullButton className={styles.button} small onClick={onClickConfirm}>
                    <FormattedMessage {...messages.cookies_confirm} />
                </FullButton>
            </div>
            <div className={classNames([styles.buttons, styles.second])}>
                <FullButton className={styles.button} onClick={onClickAccept}>
                    <FormattedMessage {...messages.cookies_accept} />
                </FullButton>
                <FullButton className={styles.button} onClick={onClickDeny}>
                    <FormattedMessage {...messages.cookies_reject} />
                </FullButton>
            </div>
        </div>
    );
};

CookiesForm.propTypes = propTypes;
CookiesForm.defaultProps = defaultProps;

export default CookiesForm;
